import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectItem } from '../../shared';

@Component({
    selector: 'ef-burden-filters-container',
    templateUrl: './burden-filters-container.component.html',
    styleUrls: ['./burden-filters-container.component.scss'],
    standalone: false
})
export class BurdenFiltersContainerComponent implements OnInit {
    @Input() contracts: SelectItem[];
    @Output() SelectContract = new EventEmitter();
    @Output() ToggleDetails = new EventEmitter<boolean>();

    constructor(private store: Store) {}
    ngOnInit(): void {}
}
